import React from 'react';

import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from 'react-router-dom';

import { useFavoritePages } from '@src/effects/useFavoritePages';
import { isFailed, isLoading } from '@src/global/status';

import ApiError from '@src/components/common/Errors/ApiError';
import { MENU_ITEMS_NUM } from '@src/components/FavoritePages/helpers';
import LoadingElement from '@src/components/loader';

const PARAMS = { limit: MENU_ITEMS_NUM };

const FavoritesMenuList = () => {
    const [status, data] = useFavoritePages(PARAMS);

    if (isLoading(status)) {
        return (
            <Dropdown.Item>
                <LoadingElement />
            </Dropdown.Item>
        );
    }

    if (isFailed(status)) {
        return (
            <Dropdown.Item>
                <ApiError error={data} />
            </Dropdown.Item>
        );
    }

    return data.slice(0, MENU_ITEMS_NUM).map((link) => (
        <Dropdown.Item
            key={`link-${link.path}`}
            as={Link}
            to={link.path}
        >
            {link.title}
        </Dropdown.Item>
    ));
};

export default React.memo(FavoritesMenuList);
